import { ISelectTimeSlotsContext } from './types';

export const isDaySelected = (context: ISelectTimeSlotsContext) =>
  Boolean(context.daySelected);

export const isHourSelected = (context: ISelectTimeSlotsContext) =>
  Boolean(context.hourSelected);
